// LLui owns the visual foundation. Dungeonlogs adds only domain semantics and
// app-specific layout after the complete light/dark baseline.
import './llui-theme.css';
import '@dl/ui/theme-extensions.css';
import '@dl/ui/bottom-sheet.css';
import '@dl/ui/atoms/status-pill.css';
import '@dl/ui/atoms/reveal-chip.css';
import '@dl/ui/atoms/provenance-badge.css';
import '@dl/ui/atoms/modal.css';
import '@dl/ui/atoms/popover.css';
import '@dl/ui/atoms/dropdown-menu.css';
import '@dl/ui/atoms/card.css';
import '@dl/ui/atoms/form-field.css';
import '@dl/ui/atoms/collapse.css';
import '@dl/ui/atoms/select-input.css';
import '@dl/ui/atoms/color-picker.css';
import '@dl/ui/atoms/calendar-date-picker.css';
import '@dl/ui/atoms/date-field.css';
import '@dl/ui/atoms/calendar-editor.css';
import '@dl/ui/atoms/text-input.css';
import '@dl/ui/atoms/badge.css';
import '@dl/ui/atoms/entity-icon.css';
import '@dl/ui/molecules/empty-state.css';
import '@dl/ui/molecules/page-header.css';
import '@dl/ui/molecules/entity-card.css';
import '@llui/markdown/styles/theme.css';
import '@llui/markdown-editor/styles/editor.css';
import './styles.css';

import { initTheme } from '@dl/ui';
import { mountApp } from '@llui/dom';

import { App } from './app.js';

// Apply the persisted theme synchronously before paint so the page
// never flashes the wrong palette.
initTheme();

const root = document.getElementById('app');
if (!root) throw new Error('expected #app root element');

const handle = mountApp(root, App);

// Dev/test-only: expose the app handle so Playwright specs (and a
// curious developer at the console) can call `__dlApp.getState()` to
// inspect Model. Vite tree-shakes this on prod (`import.meta.env.DEV`
// is statically false), and we also gate on a `?dl_expose=1` query
// param to keep it out of CI by default.
if (
  (import.meta as { env?: { DEV?: boolean } }).env?.DEV ||
  (typeof location !== 'undefined' && new URLSearchParams(location.search).has('dl_expose'))
) {
  (window as unknown as { __dlApp?: unknown }).__dlApp = handle;
}
